import { createContext, useContext, useState } from "react";

const ROLES = [
  "Plant/Site Manager", "Process Engineer", "Energy Manager", "EHS Lead",
  "Maintenance Lead", "Finance/Business Lead", "Sustainability Lead",
];

const RoleContext = createContext(null);

export function RoleProvider({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem("oim-role") || ROLES[0]);

  const changeRole = (r) => {
    localStorage.setItem("oim-role", r);
    setRole(r);
  };

  return <RoleContext.Provider value={{ role, roles: ROLES, changeRole }}>{children}</RoleContext.Provider>;
}

export function useRole() {
  return useContext(RoleContext);
}
